import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { CallBarContent } from './call-bar-content';
import { CallBarHead } from './call-bar-head';
import { CALL_BAR_HEIGHT } from './constants';

type Props = {
  className?: string;
  isExpanded: boolean;
  children: React.ReactNode;
  toggleOpen: () => void;
};

export const ActiveCallBar = ({ toggleOpen, className, isExpanded, children }: Props) => {
  return (
    <section
      data-trackingid='softphone-widget-expand-collapse'
      id='softphone-call-bar-widget'
      onClick={toggleOpen}
      css={styles}
      className={className}
    >
      <div className='lead'>
        <CallBarHead showContent={isExpanded} />
      </div>
      <div className='content'>
        <CallBarContent showContent={isExpanded} />
      </div>
      <div className='trail'>{children}</div>
    </section>
  );
};

const styles = css`
  display: flex;
  background-color: ${theme.colors.neutral90};
  border-radius: ${theme.borderRadius.medium};
  width: 100%;
  display: flex;
  height: ${CALL_BAR_HEIGHT}px;
  align-items: center;
  cursor: pointer;
  padding: ${theme.spacing(1, 2)};
  border: 1px solid white;
  z-index: ${theme.zIndex.modal};
  -webkit-tap-highlight-color: transparent;
  -moz-tap-highlight-color: transparent;
  -o-tap-highlight-color: transparent;
  tap-highlight-color: transparent;

  .lead,
  .trail {
    display: flex;
    align-items: center;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    gap: ${theme.spacing(1)};
  }

  .content {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: ${theme.spacing(0, 1)};
    flex: 1;
    gap: ${theme.spacing(1)};
  }
`;
